module.exports = __webpack_public_path__ + "static/box2-b15fcfa379965e50ab427d0060418845.jpg";